export default ".cw-textarea[data-v-67922113]{height:auto;display:block;width:100%;touch-action:none;min-height:40px}"